var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "span",
          [
            _vm._v("Vendor Licenses " + _vm._s(_vm.licenseListTitle) + " "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "20px" },
                attrs: {
                  disabled: this.licenseListLoading,
                  type: "secondary",
                  size: "mini",
                },
                on: { click: _vm.handleAddLicense },
              },
              [_vm._v("Add License")]
            ),
            _c(
              "span",
              { staticStyle: { float: "right", "font-weight": "normal" } },
              [_vm._v(_vm._s(_vm.licenseTotal) + " Licenses")]
            ),
          ],
          1
        ),
      ]),
      _c("VendorLicensesTable", {
        attrs: {
          componentkey: _vm.componentKey,
          list: _vm.licenseList,
          listLoading: _vm.licenseListLoading,
        },
        on: { handleDeleteMultiple: _vm.handleLicenseDeleteMultiple },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Vendor License",
            visible: _vm.editLicenseDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editLicenseDialogVisible = $event
            },
          },
        },
        [
          _c("EditLicenseDialog", {
            attrs: {
              value: _vm.editLicense,
              "vendor-id": _vm.value.vendorId,
              dialogVisible: _vm.editLicenseDialogVisible,
              copyable: "",
              boxed: "",
            },
            on: { close: _vm.handleLicenseDialogClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }